import { useEffect, useState } from 'react';
import { api, constants } from '../utils';

export default function usePostStockStatusGridData(call, currentState) {
  const [list, setList] = useState([]);  	
  useEffect(() => {
    if(!call) {
        setList([]); 
        return;  
    }
    const payload = constants.GenViewDataPayLoad(currentState)  
    
    api.post("Inventory/SearchStockStatus", payload)
      .then(response => {
        if(response.data.success){
            return response.data
        } else {
           throw new Error("Error searching for stock status.");
        }
      }).then(data => setList(data.searchStockData))
      .catch(api.catchHandler);
  }, [call, currentState]);

  return list;
}